import React from "react";

export default function SearchButton() {
  return (
    <>
      <button className="search-button">Search 🔍</button>
    </>
  );
}
